export default __webpack_public_path__ + "static/media/balance-mir-white.54a636f7.svg";